import { Container } from "react-bootstrap";

import "./prenota.css";
import Table from "react-bootstrap/Table";
import Footer from "../footer/Footer";
import { useTranslation } from "react-i18next";
function Prenota() {
  const { t } = useTranslation();
  return (
    <>
      <Container id="container">
        <div className="paragprenota">
          <hr></hr>
          <h1 id="Orari"> {t("orari")}</h1>
          <hr />
          <Table striped="columns" className="mb-5">
            <thead>
              <tr>
                <th> {t("giorno")}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td> {t("lunedi")}</td>
                <td>12:00h-15:00h / 19:00h-23:00h</td>
              </tr>
              <tr>
                <td> {t("martedi")}</td>
                <td>12:00h-15:00h / 19:00h-23:00h</td>
              </tr>
              <tr>
                <td> {t("mercoledi")}</td>
                <td>12:00h-15:00h / 19:00h-23:00h</td>
              </tr>
              <tr>
                <td> {t("giovedi")}</td>
                <td>12:00h-15:00h / 19:00h-23:00h</td>
              </tr>
              <tr>
                <td> {t("venerdi")}</td>
                <td>12:00h-15:00h / 19:00h-23:00h</td>
              </tr>
              <tr>
                <td> {t("sabato")}</td>
                <td>12:00h-15:00h / 19:00h-23:00h</td>
              </tr>
              <tr>
                <td> {t("domenica")}</td>
                <td>12:00h-15:00h / 19:00h-23:00h</td>
              </tr>
            </tbody>
          </Table>
        </div>
      </Container>
    </>
  );
}

export default Prenota;
